<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-1 text-gray-800 font-weight-bold">Auto Klaim</h5>
      <p class="mb-4">Paxel | Customer Excellence | Tickets | Claim</p>
    </div>
    <b-row>
      <b-col md="2" class="pr-0">
        <b-button
          block
          @click="menu = false"
          :variant="!menu ? 'light':''"
          :class="!menu ? 'bg-white text-primary':'bg-primary text-white'"
          class="border-light"
          size="lg"
        >Formulir</b-button>
      </b-col>
      <b-col md="2" class="pl-0">
        <b-button
          block
          @click="getLogs()"
          :variant="menu ? 'light':''"
          :class="menu ? 'bg-white text-primary':'bg-primary text-white'"
          size="lg"
        >Log</b-button>
      </b-col>
    </b-row>
    <b-card class="text-left">
      <b-row>
        <b-col>
          <h6>
            <router-link :to="{name: 'cxAutoClaim'}" class="text-primary h4 text-decoration-none">
              <i class="fas fa-long-arrow-alt-left mr-2"></i>Kembali
            </router-link>
          </h6>
          <br />
          <h5
            v-show="items.transfer_user_from && items.transfer_user_from.status && IsUserProcessedBy"
            class="text-danger mb-3"
          >{{items.transfer_user_from.fullname != "" ? 
              `Tiket ditransfer dari ` + items.transfer_user_from.fullname + ` oleh ` + items.transfer_user_by.fullname : 
              `Tiket ditransfer oleh ` + items.transfer_user_by.fullname}}</h5>
          <h5
            v-show="items.processed_by.status && !IsUserProcessedBy"
            class="text-danger mb-3"
          >Tiket sedang diproses oleh {{items.processed_by.fullname}}</h5>
          <h5
            v-show="items.approval.status"
            class="text-danger mb-3"
          >Disetujui oleh {{items.approval.fullname}}</h5>
          <h5
            v-show="items.acknowledge.status"
            class="text-danger"
          >Diketahui oleh {{items.acknowledge.fullname}}</h5>
        </b-col>
      </b-row>
      <br />
      <div v-if="loading" class="d-flex justify-content-center mb-3">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
      <b-row v-else>
        <transition name="fade" mode="out-in">
          <b-col id="print" v-if="!menu" md="8" :key="menu">
            <b-row>
              <b-col class="text-left" md="5">
                <b>Nomor Tiket:</b>
                <p v-if="editClaim">{{items.ticket_no}}</p>
                <input
                  v-else
                  v-model="items.ticket_no"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Title In Bahasa Indonesia"
                />
              </b-col>
              <b-col md="5">
                <b>Nomer Resi :</b>
                <p v-if="editClaim">{{items.shipment_code}}</p>
                <input
                  v-else
                  v-model="items.shipment_code"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Title In Bahasa Indonesia"
                />
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col md="5">
                <b>No Akun :</b>
                <p v-if="editClaim">{{items.company_account_number}}</p>
                <input
                  v-else
                  v-model="items.company_account_number"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Title In Bahasa Indonesia"
                />
              </b-col>
              <b-col md="5">
                <b>Nama Perusahaan :</b>
                <p v-if="editClaim">{{items.company_name}}</p>
                <input
                  v-else
                  v-model="items.company_name"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Title In Bahasa Indonesia"
                />
              </b-col>
            </b-row>
            <br />
            <h4>
              <b @click="claim_menu = !claim_menu" style="cursor: pointer;">
                Yang Mengajukan Claim &nbsp;
                <i v-if="claim_menu" class="fas fa-sort-down"></i>
                <i v-else class="fas fa-sort-up"></i>
              </b>
            </h4>
            <br />
            <transition name="slide">
              <b-row v-show="claim_menu">
                <b-col>
                  <b-row>
                    <b-col class="text-left" md="4">
                      <b>Nama :</b>
                      <p v-if="editClaim">{{items.name}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        v-model="items.name"
                        name="name"
                        data-vv-as="Name"
                        id="input-1"
                        class="form-control"
                        placeholder="Name"
                      />
                      <b-form-invalid-feedback
                        id="input-name-feedback"
                      >{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col md="6">
                      <b>Sebagai :</b>
                      <p v-if="editClaim">{{items.send_as}}</p>
                      <b-form-radio-group
                        id="radio-slots"
                        v-else
                        v-validate="'required'"
                        v-model="items.send_as"
                        name="send_as"
                        data-vv-as="Sebagai"
                      >
                        <b-form-radio value="pengirim">Pengirim</b-form-radio>
                        <b-form-radio value="penerima">Penerima</b-form-radio>
                      </b-form-radio-group>
                      <b-form-invalid-feedback
                        id="input-as-feedback"
                      >{{ veeErrors.first('send_as') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col md="4">
                      <b>No. Telepon/HP :</b>
                      <p v-if="editClaim">{{items.contact_number}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        v-model="items.contact_number"
                        name="contact_number"
                        data-vv-as="Telepon"
                        id="input-1"
                        class="form-control"
                        placeholder="Telepon"
                      />
                      <b-form-invalid-feedback
                        id="input-contact_number-feedback"
                      >{{ veeErrors.first('contact_number') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col md="6">
                      <b>Email :</b>
                      <p v-if="editClaim">{{items.email}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        v-model="items.email"
                        name="email"
                        data-vv-as="Email"
                        id="input-1"
                        class="form-control"
                        placeholder="Email"
                      />
                      <b-form-invalid-feedback
                        id="input-email-feedback"
                      >{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col md="4">
                      <b>Nama Pengirim :</b>
                      <p v-if="editClaim">{{items.sender_name}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        v-model="items.sender_name"
                        name="sender_name"
                        data-vv-as="Nama Pengirim"
                        id="input-1"
                        class="form-control"
                        placeholder="Nama Pengirim"
                      />
                      <b-form-invalid-feedback
                        id="input-sender_name-feedback"
                      >{{ veeErrors.first('sender_name') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col md="6">
                      <b>Alamat Pengirim :</b>
                      <p v-if="editClaim">{{items.sender_address}}</p>
                      <b-form-textarea
                        id="textarea"
                        v-model="items.sender_address"
                        v-else
                        v-validate="'required'"
                        name="sender_address"
                        data-vv-as="Alamat Pengirim"
                        placeholder="Alamat Pengirim"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <p
                        class="text-danger"
                        style="width:100%;margin-top:.25rem;font-size: 80%;"
                      >{{ veeErrors.first('sender_address') }}</p>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col md="4">
                      <b>Nama Penerima :</b>
                      <p v-if="editClaim">{{items.receiver_name}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        v-model="items.receiver_name"
                        name="receiver_name"
                        data-vv-as="Nama Penerima"
                        id="input-1"
                        class="form-control"
                        placeholder="Nama Penerima"
                      />
                      <b-form-invalid-feedback
                        id="input-receiver_name-feedback"
                      >{{ veeErrors.first('receiver_name') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col md="6">
                      <b>Alamat Penerima :</b>
                      <p v-if="editClaim">{{items.receiver_address}}</p>
                      <b-form-textarea
                        id="textarea"
                        v-model="items.receiver_address"
                        v-else
                        v-validate="'required'"
                        name="receiver_address"
                        data-vv-as="Alamat Penerima"
                        placeholder="Alamat Penerima"
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <p
                        class="text-danger"
                        style="width:100%;margin-top:.25rem;font-size: 80%;"
                      >{{ veeErrors.first('receiver_address') }}</p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </transition>

            <br />
            <h4>
              <b @click="claim_info = !claim_info" style="cursor: pointer;">
                Informasi Mengenai Claim
                <i v-if="claim_info" class="fas fa-sort-down"></i>
                <i v-else class="fas fa-sort-up"></i>
              </b>
            </h4>
            <br />
            <transition name="slide">
              <b-row v-show="claim_info">
                <b-col>
                  <b-row>
                    <b-col>
                      <b>Jenis Paket :</b>
                      <p v-if="editClaim">{{items.item_type_value}}</p>
                      <input
                        v-else
                        v-model="items.item_type_value"
                        v-validate="'required'"
                        name="jenis_barang"
                        data-vv-as="Jenis Paket"
                        id="input-1"
                        class="form-control"
                        placeholder="Jenis Paket"
                      />
                      <p
                        class="text-danger"
                        style="width:100%;margin-top:.25rem;font-size: 80%;"
                      >{{ veeErrors.first('jenis_barang') }}</p>
                    </b-col>
                    <b-col>
                      <b>Isi Paket :</b>
                      <p v-if="editClaim">{{items.item_type_description}}</p>
                      <input
                        v-else
                        v-model="items.item_type_description"
                        v-validate="'required'"
                        name="deskripsi_barang"
                        data-vv-as="Isi Paket"
                        id="input-1"
                        class="form-control"
                        placeholder="Isi Paket"
                      />
                      <b-form-invalid-feedback
                        id="input-deskripsi_barang-feedback"
                      >{{ veeErrors.first('deskripsi_barang') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b>Alasan Claim :</b>
                      <br />
                      <br />
                      <label class="mb-0" v-if="editClaim">
                        <span v-for="item in claim_reason" :key="item">
                          <label class="mb-0" v-for="coba in items.claim_reasons" :key="coba">
                            <li v-if="coba == item.id">{{item.description}}</li>
                          </label>
                          &nbsp;
                        </span>
                      </label>
                      <!-- <b-form-checkbox-group
                        v-else
                        v-validate="'required'"
                        name="alasan_claim"
                        data-vv-as="Alasan Claim"
                        id="checkbox-group-2"
                        v-model="items.claim_reasons"
                      >
                        <b-form-checkbox
                          v-for="reason in claim_reason"
                          :key="reason.id"
                          :value="reason.id"
                        >{{reason.description}}</b-form-checkbox>
                      </b-form-checkbox-group> -->
                      <b-form-radio-group
                        v-else
                        v-validate="'required'"
                        name="alasan_claim"
                        data-vv-as="Alasan Claim"
                        id="radio-group-2"
                        v-model="items.claim_reasons[0]"
                      >
                        <b-form-radio
                          v-for="reason in claim_reason"
                          :key="reason.id"
                          :value="reason.id"
                        >{{reason.description}}</b-form-radio>
                      </b-form-radio-group>
                      <p
                        class="text-danger"
                        style="width:100%;margin-top:.25rem;font-size: 80%;"
                      >{{ veeErrors.first('alasan_claim') }}</p>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Apakah paket dikirim dengan asuransi tambahan?</b>
                      <p v-if="editClaim">{{items.is_with_additional_insurance ? "Yes":"No"}}</p>
                      <b-row v-else>
                        <b-col md="3">
                          <b-form-radio-group
                            id="radio-slots"
                            v-validate="'required'"
                            v-model="items.is_with_additional_insurance"
                            name="as"
                            data-vv-as="Sebagai"
                          >
                            <b-form-radio :value="false">Tidak</b-form-radio>
                            <b-form-radio :value="true">Ya</b-form-radio>
                          </b-form-radio-group>
                        </b-col>
                        <b-col md="5">
                          <input
                            :disabled="!asuransi"
                            v-model="items.additional_insurance_amount"
                            name="asuransi"
                            id="input-1"
                            class="form-control"
                            placeholder="Asuransi"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Nominal pengajuan</b>
                      <p v-if="editClaim">Rp. {{items.claim_amount}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        name="claim_amount"
                        v-model="items.claim_amount"
                        data-vv-as="Nominal pengajuan"
                        id="input-1"
                        class="form-control"
                        placeholder="Nominal pengajuan"
                      />
                      <b-form-invalid-feedback
                        id="input-claim_amount-feedback"
                      >{{ veeErrors.first('claim_amount') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Nama Bank</b>
                      <p v-if="editClaim">{{items.account_bank}}</p>
                      <!-- <input
                        v-else
                        v-validate="'required'"
                        name="account_bank"
                        v-model="items.account_bank"
                        data-vv-as="Nama Bank"
                        id="input-1"
                        class="form-control"
                        placeholder="Nama Bank"
                      /> -->
                      <b-form-select
                        v-else
                        :value="items.account_bank"
                        name="account_bank"
                        class="my-0"
                        id="input-1"
                        data-vv-as="Nama Bank"
                        v-validate="'required'"
                        v-on:change="updateAccountBank(value, $event)"
                      >
                        <option
                          v-for="bank in listBank" :key="bank.code"
                          :value="bank.name"
                        >
                        {{bank.name}}
                        </option>
                      </b-form-select>
                      <b-form-invalid-feedback
                        id="input-account_bank-feedback"
                      >{{ veeErrors.first('account_bank') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col>
                      <b>No Rekening</b>
                      <p v-if="editClaim">{{items.account_number}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        name="no_rekening"
                        data-vv-as="No Rekening"
                        id="input-1"
                        v-model="items.account_number"
                        class="form-control"
                        placeholder="No Rekening"
                      />
                      <b-form-invalid-feedback
                        id="input-no_rekening-feedback"
                      >{{ veeErrors.first('no_rekening') }}</b-form-invalid-feedback>
                    </b-col>
                    <b-col>
                      <b>Nama Sesuai No Rekening</b>
                      <p v-if="editClaim">{{items.account_number_holder_name}}</p>
                      <input
                        v-else
                        v-validate="'required'"
                        name="nama_no_rek"
                        v-model="items.account_number_holder_name"
                        data-vv-as="Nama Sesuai No Rekening"
                        id="input-1"
                        class="form-control"
                        placeholder="Nama Sesuai No Rekening"
                      />
                      <b-form-invalid-feedback
                        id="input-nama_no_rek-feedback"
                      >{{ veeErrors.first('nama_no_rek') }}</b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Deskripsi Kendala :</b>
                      <p v-if="editClaim">{{items.message}}</p>
                      <b-form-textarea
                        id="textarea"
                        v-model="items.message"
                        v-else
                        name="pesan"
                        data-vv-as="Deskripsi Kendala"
                        placeholder="Enter something..."
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                      <p
                        class="text-danger"
                        style="width:100%;margin-top:.25rem;font-size: 80%;"
                      >{{ veeErrors.first('pesan') }}</p>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Asuransi :</b>
                      <p>Rp. {{items.shipment_insurance}}</p>
                    </b-col>
                    <b-col>
                      <b class="text-danger">Jaminan Makanan Aman :</b>
                      <p class="text-danger">{{items.food_safe_guarantee ? "Yes": "No"}}</p>
                    </b-col>
                    <b-col>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </transition>
            <br />
            <h4>
              <b @click="claim_dokumen = !claim_dokumen" style="cursor: pointer;">
                Dokumen Pendukung
                <i v-if="claim_dokumen" class="fas fa-sort-down"></i>
                <i v-else class="fas fa-sort-up"></i>
              </b>
            </h4>
            <br />
            <transition name="slide">
              <b-row v-show="claim_dokumen">
                <b-col>
                  <b-row>
                    <b-col>
                      <b>Foto Barang : Maks 2MB dengan format JPG, atau PNG</b>
                      <div v-for="(value,k) in items.image" :key="k">
                        <input
                          type="file"
                          ref="image"
                          name="image"
                          v-validate="'image|minAndEqualSize:2048|ext:jpg,png,gif,jpeg'"
                          style="display: none"
                          v-on:change="onChangeimage(k)"
                        />
                        <b-row v-if="value == '' || imageItem[k] == 'delete'">
                          <b-col md="9" class="py-2" v-if="!editClaim">
                            <b-card body-class="py-2 px-2">
                              <card-body name="foto-barang">
                                <b-row>
                                  <b-col md="8" class="text-primary mt-2">
                                    <i class="fas fa-paperclip"></i>&nbsp;
                                    <b>{{image.name || 'Foto Barang'}}</b>
                                    <sup class="text-secondary pl-3">(Maks 2MB dengan format JPG, atau PNG)</sup>
                                  </b-col>
                                  <b-col class="text-right" align="right">
                                    <b-button
                                      @click="$refs.image[k].click()"
                                      variant="primary"
                                      class="ml-5"
                                    >Select File</b-button>
                                  </b-col>
                                </b-row>
                              </card-body>
                            </b-card>
                          </b-col>
                        </b-row>
                        <b-row v-else-if="value || imageItem[k]">
                          <b-col md="9">
                            <img v-if="!urlImage[k]" :src="value" width="100%" class="py-2" alt />
                            <img v-else :src="urlImage[k]" width="100%" class="py-2" alt />
                          </b-col>
                          <b-col v-if="!editClaim" md="3">
                            <a
                              @click="deleteDataImage(k)"
                              style="cursor: pointer;"
                              class="text-decoration-none"
                            >
                              <i class="fas fa-times fa-2x text-danger"></i>
                            </a>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Invoice Pembelian Barang : Maks 2MB dengan format JPG, PNG, atau PDF</b>
                      <br />
                      <input
                        type="file"
                        ref="invoice_image"
                        name="invoice_image"
                        data-vv-as="Invoice Pembelian Barang"
                        v-validate="'minAndEqualSize:2048|ext:jpg,png,gif,jpeg,pdf'"
                        style="display: none"
                        v-on:change="onChangeImageSelected('invoice_image')"
                      />
                      <b-row v-if="items.invoice_image == '' || invoice_image == 'delete' ">
                        <b-col md="9" v-if="!editClaim">
                          <b-card body-class="py-2 px-2">
                            <card-body name="invoice-barang">
                              <b-row>
                                <b-col md="9" class="text-primary mt-2">
                                  <i class="fas fa-paperclip"></i>&nbsp;
                                  <b>{{image.name || 'Invoice Pembelian'}}</b>
                                  <sup class="text-secondary pl-3">(Maks 2MB dengan format JPG, PNG, atau PDF)</sup>
                                </b-col>
                                <b-col class="text-right" align="right">
                                  <b-button
                                    @click="$refs.invoice_image.click()"
                                    class="ml-5"
                                    variant="primary"
                                  >Select File</b-button>
                                </b-col>
                              </b-row>
                            </card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row v-else-if="items.invoice_image || invoice_image">
                        <b-col md="9">
                          <img
                            v-if="!invoice_image && !checkPDFFile(items.invoice_image)"
                            :src="items.invoice_image"
                            width="100%"
                            class="py-2"
                            alt
                          />
                          <embed
                            v-if="!invoice_image && checkPDFFile(items.invoice_image)"
                            :src="items.invoice_image"
                            type="application/pdf" width="100%" height="500px" class="py-2"
                          />
                          <img
                            v-else-if="invoice_image && !checkPDFFile(urlImageSelected.invoice_image)"
                            :src="urlImageSelected.invoice_image"
                            width="100%"
                            class="py-2"
                            alt
                          />
                          <embed
                            v-else-if="invoice_image && checkPDFFile(urlImageSelected.invoice_image)"
                            :src="urlImageSelected.invoice_image"
                            type="application/pdf" width="100%" height="500px" class="py-2"
                          />
                        </b-col>
                        <b-col v-if="!editClaim" md="3">
                          <a
                            @click="deleteDataPendukung('invoice_image')"
                            style="cursor: pointer;"
                            class="text-decoration-none"
                          >
                            <i class="fas fa-times fa-2x text-danger"></i>
                          </a>
                        </b-col>
                      </b-row>
                      <p
                        class="text-danger"
                        style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                      >
                        {{ veeErrors.first("invoice_image") }}
                      </p>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row>
                    <b-col>
                      <b>Foto KTP : Maks 2MB dengan format JPG, PNG, atau PDF</b>
                      <br />
                      <input
                        type="file"
                        ref="identity_card_image"
                        name="identity_card_image"
                        data-vv-as="Foto KTP"
                        v-validate="'minAndEqualSize:2048|ext:jpg,png,gif,jpeg,pdf'"
                        style="display: none"
                        v-on:change="onChangeImageSelected('identity_card_image')"
                      />
                      <b-row
                        v-if="items.identity_card_image == '' || identity_card_image == 'delete'"
                      >
                        <b-col md="9" v-if="!editClaim">
                          <b-card body-class="py-2 px-2">
                            <card-body name="foto-ktp">
                              <b-row>
                                <b-col md="8" class="text-primary mt-2">
                                  <i class="fas fa-paperclip"></i>&nbsp;
                                  <b>{{image.name || 'Foto KTP'}}</b>
                                  <sup class="text-secondary pl-3">(Maks 2MB dengan format JPG, PNG, atau PDF)</sup>
                                </b-col>
                                <b-col class="text-right" align="right">
                                  <b-button
                                    @click="$refs.identity_card_image.click()"
                                    variant="primary"
                                    class="ml-5"
                                  >Select File</b-button>
                                </b-col>
                              </b-row>
                            </card-body>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row v-else-if="items.identity_card_image || identity_card_image">
                        <b-col md="9">
                          <img
                            v-if="!identity_card_image  && !checkPDFFile(items.identity_card_image)"
                            :src="items.identity_card_image"
                            width="100%"
                            class="py-2"
                            alt
                          />
                          <embed
                            v-if="!identity_card_image && checkPDFFile(items.identity_card_image)"
                            :src="items.identity_card_image"
                            type="application/pdf" width="100%" height="500px" class="py-2"
                          />
                          <img
                            v-else-if="identity_card_image && !checkPDFFile(urlImageSelected.identity_card_image)"
                            :src="urlImageSelected.identity_card_image"
                            width="100%"
                            class="py-2"
                            alt
                          />
                          <embed
                            v-else-if="identity_card_image && checkPDFFile(urlImageSelected.identity_card_image)"
                            :src="urlImageSelected.identity_card_image"
                            type="application/pdf" width="100%" height="500px" class="py-2"
                          />
                        </b-col>
                        <b-col v-if="!editClaim" md="3">
                          <a
                            @click="deleteDataPendukung('identity_card_image')"
                            style="cursor: pointer;"
                            class="text-decoration-none"
                          >
                            <i class="fas fa-times fa-2x text-danger"></i>
                          </a>
                        </b-col>
                      </b-row>
                      <p
                        class="text-danger"
                        style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                      >
                        {{ veeErrors.first("identity_card_image") }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </transition>
          </b-col>
          <b-col v-else md="8" :key="menu">
            <!-- {{logs}} -->
            <b-row>
              <b-col md="3" style="margin-left:30px;">
                <h4>Time</h4>
              </b-col>
              <b-col>
                <h4>Note</h4>
              </b-col>
            </b-row>
            <b-row class="my-3" v-for="log in logs" :key="log">
              <b-col style="margin-left:30px;" md="3">{{log.datetime | DateTime}}</b-col>
              <b-col class="pr-5">
                {{log.fullname}}
                <span v-for="(detail,key) in log.logs_detail" :key="key">
                  {{detail}}
                  {{log.logs_detail.length == key+1 ? '':', '}}
                </span>
              </b-col>
            </b-row>
          </b-col>
        </transition>
        <b-col md="4">
          <p>
            <b-button
              v-show="session.role == 'superadmin' || session.role == 'claim_manager'"
              block
              :disabled="!editClaim || items.status == 'rejected' || items.status == 'refunded'"
              :variant="!editClaim ? '' : 'primary'"
              size="lg"
              @click="transferUserTakenShow = !transferUserTakenShow"
            >
              <span><i style='font-size:14px' class='fas'>&#xf362;</i> TRANSFER TICKET TO</span>
            </b-button>
            <b-button
              v-show="!items.processed_by.status"
              block
              :disabled="!editClaim || items.processed_by.status || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager'"
              :variant="!editClaim || items.processed_by.status? '':'primary'"
              size="lg"
              @click="processClaim()"
            >
              <span v-if="!items.processed_by.status">AMBIL TIKET</span>
              <span v-else>
                CLAIM TELAH DIAMBIL
                <i class="fas fa-check"></i>
              </span>
            </b-button>
            <b-button
              v-show="items.processed_by.status"
              block
              :disabled="!editClaim || items.approval.status || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
              :variant="!editClaim || items.approval.status? '':'primary'"
              size="lg"
              @click="setujuiClaim()"
            >
              <span v-if="!items.approval.status">PROSES CLAIM</span>
              <span v-else>
                CLAIM DIPROSES
                <i class="fas fa-check"></i>
              </span>
            </b-button>
            <!-- <b-button
              block
              :disabled="!editClaim || !items.approval.status || items.acknowledge.status || session.role != 'operation' && session.role != 'superadmin' && session.role != 'claim_manager'"
              :variant="!editClaim || !items.approval.status || items.acknowledge.status ? '':'primary'"
              @click="acknowledge()"
              size="lg"
            >
              <span v-if="!items.acknowledge.status">MENGETAHUI</span>
              <span v-else>
                CLAIM DIKETAHUI
                <i class="fas fa-check"></i>
              </span>
            </b-button> -->
            <b-row class="mt-2">
              <b-col>
                <b-button
                  :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager'"
                  :variant="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' ? 'outline-secondary no-hover':'outline-primary'"
                  block
                  @click="copy()"
                >
                  <i class="fas fa-copy mr-2"></i>Salin Tautan
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
                  :variant="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy) ? 'outline-secondary no-hover':'outline-primary'"
                  block
                  @click="emailShow = !emailShow"
                >
                  <i class="fas fa-paper-plane mr-2"></i>Kirim ke Email
                </b-button>
              </b-col>
            </b-row>
          </p>
          <b-card class="text-left bg-gray-100">
            <b-row v-show="this.items.processed_by.status">
              <b-col md="6">
                <p>Tiket Diambil Oleh:</p>
                <p v-if="editClaim">{{items.processed_by.fullname}}</p>
                <input
                  v-else
                  v-model="items.processed_by.fullname"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Claim diproses oleh"
                />
              </b-col>
              <b-col md="6">
                <p>Tanggal Ambil Tiket:</p>
                <p v-if="editClaim">{{items.processed_by.datetime | DateTime}}</p>
                <input
                  v-else
                  type="datetime"
                  v-model="formattedProcessedByDatetime"
                  id="input-1"
                  disabled
                  class="form-control"
                  placeholder="Claim diproses oleh"
                />
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col class="text-left" md="12">
                <b-form-group id="fieldset-1" label="Status" class="mb-0" label-for="input-1">
                  <!-- <b-form-select
                    @change="changeStatus"
                    :value="items.status"
                    class="my-0"
                    :disabled="!editClaim"
                    :class="items.status === 'new' ? 'text-warning':'' || items.status === 'on review' ? 'text-info':''|| items.status === 'resolved' ? 'text-primary':''|| items.status === 'rejected' ? 'text-danger':'' "
                    id="input-1"
                  >
                    <option value="new" class="text-warning">New</option>
                    <option value="on review" class="text-info">On Review</option>
                    <option value="resolved" class="text-primary">Resolved</option>
                    <option value="rejected" class="text-danger">Rejected</option>
                  </b-form-select>-->
                  <select-status v-model="items.status" :editClaim="editClaim" :isUserProcessedBy="IsUserProcessedBy" :rejectReasonValue="items.reject_reason.id" :rejectReasons="claim_reject_reasons"></select-status>
                </b-form-group>
              </b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col class="text-left" md="12">
                <b-form-group id="fieldset-1" label="Reject Reason" class="mb-0" label-for="input-1">
                  <select-reject-reason v-model="items.reject_reason.id" :isDisabled="true" :rejectReasons="claim_reject_reasons"></select-reject-reason>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1" v-show="items.reject_reason.description == 'Others'">
              <b-col md="12" mt="1">
                <p v-if="editClaim">{{items.reject_reason.other_description}}</p>
                <input
                  v-else
                  v-model="items.reject_reason.other_description"
                  id="input-1"
                  class="form-control"
                  placeholder="Enter other reject reason here"
                />
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col class="text-left" md="12">
                <b-form-group id="fieldset-1" label="Admin Hub" class="mb-0" label-for="input-1">
                  <select-admin-hub v-model="items.admin_hub_claim.admin_hub_code" :editClaim="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)" :adminHubs="admin_hubs"></select-admin-hub>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1" v-show="items.admin_hub_claim.admin_hub_code == 'OTHERS'">
              <b-col md="12" mt="1">
                <p v-if="editClaim">{{items.admin_hub_claim.name}}</p>
                <input
                  v-else
                  v-model="items.admin_hub_claim.name"
                  id="input-1"
                  class="form-control"
                  placeholder="Enter admin hub here"
                />
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col md="8">
                <b>Waktu Kirim</b>
                <p>{{items.time_issued}}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button
                  block
                  :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
                  :variant="!editClaim ? '':'primary'"
                  @click="GetData()"
                >Lihat Data AWB</b-button>
                <b-button
                  @click="print()"
                  block
                  :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
                  :variant="!editClaim ? '':'warning'"
                >
                  <i class="fas fa-print"></i> &nbsp;Cetak Claim
                </b-button>
                <b-button
                  v-show="editClaim"
                  @click="onEditClaim()"
                  block
                  :disabled="items.status == 'rejected' ? true : session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
                  :variant="items.status == 'rejected' ? 'outline-secondary no-hover' : session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy) ? 'outline-secondary no-hover' : 'outline-primary'"
                >
                  <i class="fas fa-pen"></i>&nbsp; Edit Claim
                </b-button>
                <b-row class="mt-2" v-show="!editClaim">
                  <b-col>
                    <b-button @click="buang()" block variant="outline-primary">Buang</b-button>
                  </b-col>
                  <b-col>
                    <b-button @click="simpan()" block variant="primary">
                      <i class="fas fa-save"></i> &nbsp; Simpan
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <br />
          <h4 class="font-weight-bold">Kelengkapan Dokumen</h4>
          <b-card class="text-left bg-gray-100">
            <b-row>
              <b-col>
                <b-row>
                  <b-col>
                    <b>Kronologi</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.chronology.url,items.document.chronology.name)"
                    >{{items.document.chronology.name ? items.document.chronology.name:'-'}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b>FC SIM & STNK (Hero/Feeder)</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.hero_id_card.url,items.document.hero_id_card.name)"
                    >{{items.document.hero_id_card.name ? items.document.hero_id_card.name:'-'}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b>Foto Kendaraan & Tools Hero</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.hero_tools_and_vehicle.url,items.document.hero_tools_and_vehicle.name)"
                    >{{items.document.hero_tools_and_vehicle.name ? items.document.hero_tools_and_vehicle.name:'-'}}</p>
                  </b-col>
                </b-row>
                <!-- <b-row>
                  <b-col>
                    <b>Surat Tuntutan Ganti Rugi</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.letter_of_demand.url,items.document.letter_of_demand.name)"
                    >{{items.document.letter_of_demand.name ? items.document.letter_of_demand.name:'-'}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b>Surat Preventive Action / Laporan Kepolisian</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.preventive_action.url,items.document.preventive_action.name)"
                    >{{items.document.preventive_action.name ? items.document.preventive_action.name:"-"}}</p>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col>
                    <b>Dokumen Lainnya</b>
                    <p
                      class="text-primary"
                      style="cursor: pointer;"
                      @click="forceFileDownload(items.document.other_document.url,items.document.other_document.name)"
                    >{{items.document.other_document.name ? items.document.other_document.name:"-"}}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      :disabled="!editClaim || session.role != 'operation' && session.role != 'customer_success' &&session.role != 'mentor' && session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || items.status != 'refunded'"
                      :variant="!editClaim || session.role != 'operation' && session.role != 'customer_success' &&session.role != 'mentor' && session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || items.status != 'refunded' ? 'outline-secondary no-hover':'outline-primary'"
                      @click="modalKelengkapan = !modalKelengkapan"
                      block
                    >
                      <i class="fas fa-pen"></i>&nbsp; Edit Kelengkapan
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <!-- <br />
          <h4 class="font-weight-bold">Bukti Transfer</h4>
          <b-card body-class="py-2 px-2">
            <card-body name="bukti-transfer">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i v-show="!items.transfer_receipt.Name" class="fas fa-paperclip"></i>&nbsp;
                  <b
                    style="cursor: pointer;"
                    @click="forceFileDownload(items.transfer_receipt.Url,items.transfer_receipt.Name)"
                  >{{items.transfer_receipt.Name || 'Name'}}</b>
                  <sup v-show="!items.transfer_receipt.Name" class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="transfer_receipt"
                    name="transfer_receipt"
                    v-validate="'size:2000'"
                    style="display: none"
                    v-on:change="onChangeTransfer()"
                  />
                  <b-button
                    @click="$refs.transfer_receipt.click()"
                    :disabled="!editClaim || session.role != 'finance' && session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' || (session.role == 'claim' && !IsUserProcessedBy)"
                    :variant="!editClaim ? '':'primary'"
                    v-if="items.transfer_receipt.Name == ''"
                    class="ml-5"
                  >Select File</b-button>
                  <a
                    @click="deleteTransfer()"
                    v-else-if="items.transfer_receipt.Name || session.role != 'finance' && session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager'"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card> -->
          <br />
          <h4 class="font-weight-bold">Comments</h4>
          <b-button
            block
            :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' && session.role != 'ce'"
            :variant="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' && session.role != 'ce' ? 'outline-secondary no-hover':'outline-primary'"
            @click="commentShow = !commentShow"
          >
            <i class="fas fa-plus"></i> Add Comment
          </b-button>
          <b-card
            bg-variant="light"
            v-for="item in items.comments"
            :key="item"
            class="text-left mt-4"
          >
            <b-row>
              <b-col md="8">
                <b class="text-primary">{{item.name}}</b>
              </b-col>
              <b-col class="text-right">
                <b-link :disabled="!editClaim || session.role != 'superadmin' && session.role != 'claim' && session.role != 'claim_manager' && session.role != 'ce'" @click="del(item.id)">
                  <i class="fas fa-times text-danger"></i>
                </b-link>
              </b-col>
            </b-row>
            <p class="text-warning">{{item.date_comment | DateTime}}</p>
            <p>{{item.comment}}</p>
          </b-card>
          <b-card
            bg-variant="light"
            class="text-left mt-4"
            v-if="post_refunded_access_logs.length > 0"
          >
            <b-row>
              <b-col>
                <b>Informasi Perubahan Detail Klaim setelah Refund</b>
              </b-col>
            </b-row>
            <b-card
              bg-variant="light"
              class="text-left mt-4"
              v-for="postRefundLog in post_refunded_access_logs"
              :key="postRefundLog._id"
            >
              <b-row>
                <b-col>
                  <b>Data diubah oleh:</b>
                </b-col>
                <b-col>
                  <p>{{postRefundLog.fullname}}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>Tanggal dan Jam Ubah Data:</b>
                </b-col>
                <b-col>
                  <p>{{postRefundLog.datetime | DateTimeV2}}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>Data yang diubah:</b>
                </b-col>
                <b-col>
                  <label class="mb-0">
                    <span>
                      <ul class="mb-0" v-for="detailAccessLog in postRefundLog.logs_detail" :key="detailAccessLog" style="padding-inline-start: 10px;">
                        <li>{{detailAccessLog}}</li>
                      </ul>
                      &nbsp;
                    </span>
                  </label>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b>Alasan perubahan data:</b>
                </b-col>
                <b-col>
                  <p>{{postRefundLog.reason}}</p>
                </b-col>
              </b-row>
            </b-card>
          </b-card>
        </b-col>
        <b-col class="text-left ml-3 my-3" md="2"></b-col>
        <b-col class="my-3"></b-col>
      </b-row>
    </b-card>

    <b-modal id="modal-image1" size="xl" title="Image 1">
      <img
        src="https://s4.bukalapak.com/uploads/attachment/451051/paxel_banner_1.png"
        alt
        width="400px"
        height="200px"
      />
    </b-modal>
    <b-modal id="modal-image2" size="xl" title="Image 2">
      <img
        src="data:image/png;base64,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"
        alt
        width="200px"
        height="200px"
      />
    </b-modal>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
      <img v-if="urlImage" width height="400px" :src="urlImage" />
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
    <b-modal
      v-model="modalKelengkapan"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <h4>
        <b>Kelengkapan Dokumen</b>
      </h4>
      <br />
      <form data-vv-scope="form-document">
      <b-row>
        <b-col>
          <h6 class="font-weight-bold">Kronologi</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="kronologi">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.chronology.name == '' || chronology == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="chronology || items.document.chronology.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.chronology.name == '' || chronology == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="chronology || items.document.chronology.name"
                  >{{chronology.name ? chronology.name:items.document.chronology.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="chronology"
                    name="chronology"
                    data-vv-as="Kronologi"
                    v-validate="'minAndEqualSize:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('chronology')"
                  />
                  <b-button
                    @click="$refs.chronology.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.chronology.name == '' || chronology == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('chronology')"
                    v-else-if="chronology || items.document.chronology.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.chronology") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <h6 class="font-weight-bold">FC SIM & STNK (Hero/Feeder)</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="foto-sim">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.hero_id_card.name == '' || hero_id_card == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="hero_id_card || items.document.hero_id_card.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.hero_id_card.name == '' || hero_id_card == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="hero_id_card || items.document.hero_id_card.name"
                  >{{hero_id_card.name ? hero_id_card.name:items.document.hero_id_card.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="hero_id_card"
                    name="hero_id_card"
                    data-vv-as="FC SIM & STNK (Hero/Feeder)"
                    v-validate="'minAndEqualSize:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('hero_id_card')"
                  />
                  <b-button
                    @click="$refs.hero_id_card.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.hero_id_card.name == '' || hero_id_card == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('hero_id_card')"
                    v-else-if="hero_id_card || items.document.hero_id_card.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.hero_id_card") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <h6 class="font-weight-bold">Foto Kendaraan & Tools Hero</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="foto-kendaraan">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.hero_tools_and_vehicle.name == '' || hero_tools_and_vehicle == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="hero_tools_and_vehicle || items.document.hero_tools_and_vehicle.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.hero_tools_and_vehicle.name == '' || hero_tools_and_vehicle == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="hero_tools_and_vehicle || items.document.hero_tools_and_vehicle.name"
                  >{{hero_tools_and_vehicle.name ? hero_tools_and_vehicle.name:items.document.hero_tools_and_vehicle.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="hero_tools_and_vehicle"
                    name="hero_tools_and_vehicle"
                    data-vv-as="Foto Kendaraan & Tools Hero"
                    v-validate="'minAndEqualSize:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('hero_tools_and_vehicle')"
                  />
                  <b-button
                    @click="$refs.hero_tools_and_vehicle.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.hero_tools_and_vehicle.name == '' || hero_tools_and_vehicle == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('hero_tools_and_vehicle')"
                    v-else-if="hero_tools_and_vehicle || items.document.hero_tools_and_vehicle.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.hero_tools_and_vehicle") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <!-- <b-row>
        <b-col>
          <h6 class="font-weight-bold">Surat Tuntutan Ganti Rugi</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="surat-ganti-rugi">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.letter_of_demand.name == '' || letter_of_demand == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="letter_of_demand || items.document.letter_of_demand.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.letter_of_demand.name == '' || letter_of_demand == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="letter_of_demand || items.document.letter_of_demand.name"
                  >{{letter_of_demand.name ? letter_of_demand.name:items.document.letter_of_demand.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="letter_of_demand"
                    name="letter_of_demand"
                    data-vv-as="Surat Tuntutan Ganti Rugi"
                    v-validate="'size:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('letter_of_demand')"
                  />
                  <b-button
                    @click="$refs.letter_of_demand.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.letter_of_demand.name == '' || letter_of_demand == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('letter_of_demand')"
                    v-else-if="letter_of_demand || items.document.letter_of_demand.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.letter_of_demand") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <h6 class="font-weight-bold">Surat Preventive Action / Laporan Kepolisian</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="surat-kepolisian">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.preventive_action.name == '' || preventive_action == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="preventive_action || items.document.preventive_action.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.preventive_action.name == '' || preventive_action == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="preventive_action || items.document.preventive_action.name"
                  >{{preventive_action.name ? preventive_action.name:items.document.preventive_action.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="preventive_action"
                    name="preventive_action"
                    data-vv-as="Surat Preventive Action"
                    v-validate="'size:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('preventive_action')"
                  />
                  <b-button
                    @click="$refs.preventive_action.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.preventive_action.name == '' || preventive_action == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('preventive_action')"
                    v-else-if="preventive_action || items.document.preventive_action.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.preventive_action") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br /> -->
      <b-row>
        <b-col>
          <h6 class="font-weight-bold">Dokumen Lainnya</h6>
          <b-card body-class="py-2 px-2">
            <card-body name="dokument-lainnya">
              <b-row>
                <b-col class="text-primary mt-2">
                  <i
                    v-if="items.document.other_document.name == '' || other_document == 'delete'"
                    class="fas fa-paperclip"
                  ></i>
                  <img
                    v-else-if="other_document || items.document.other_document.name"
                    src="@/assets/ic-uploaded.svg"
                  />
                  &nbsp;
                  <b
                    v-if="items.document.other_document.name == '' || other_document == 'delete'"
                  >Name</b>
                  <b
                    v-else-if="other_document || items.document.other_document.name"
                  >{{other_document.name ? other_document.name:items.document.other_document.name}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)</sup>
                </b-col>
                <b-col md="6" class="text-right" align="right">
                  <input
                    type="file"
                    ref="other_document"
                    name="other_document"
                    data-vv-as="Dokumen Lainnya"
                    v-validate="'minAndEqualSize:2048'"
                    style="display: none"
                    v-on:change="onChangeDocument('other_document')"
                  />
                  <b-button
                    @click="$refs.other_document.click()"
                    variant="primary"
                    class="ml-5"
                    v-if="items.document.other_document.name == '' || other_document == 'delete'"
                  >Select File</b-button>
                  <a
                    @click="deleteDocument('other_document')"
                    v-else-if="other_document || items.document.other_document.name"
                    style="cursor: pointer;"
                    class="mr-2 text-decoration-none"
                  >
                    <i class="fas fa-times mt-2 text-primary"></i>
                  </a>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <b-row>
            <b-col>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("form-document.other_document") }}
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      </form>
      <b-row>
        <b-col>
          <b-button
            block
            variant="light"
            class="bg-gray-100 text-primary font-weight-bold"
            @click="batal()"
          >Batal</b-button>
        </b-col>
        <b-col>
          <b-button
            block
            variant="primary"
            class="font-weight-bold"
            @click="simpanDocument()"
          >Simpan</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="modalData" hide-header hide-footer size="xl">
      <h4>
        <b>Data AWB</b>
      </h4>
      <b-row>
        <b-col>
          <h5>
            <b>Data Pengirim</b>
          </h5>
          <b-row>
            <b-col>
              <b>Nama Pengirim</b>
              <p>{{compare ? compare.shipment_data.sender:''}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b>No Telepon Pengirim</b>
              <p>{{compare ? compare.shipment_data.sender_phone:''}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b>Alamat Pengirim</b>
              <p>{{compare ? compare.shipment_data.sender_address:''}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b>Preferred Delivery Date</b>
              <p>
                {{compare ? compare.shipment_data.prefered_delivery_date:''}},&nbsp;
                <label
                  v-if="compare"
                >{{compare.shipment_data.prefered_delivery_time_min.slice(0, 5)}}</label>
                <label v-else></label> &nbsp;-&nbsp;
                <label
                  v-if="compare"
                >{{compare.shipment_data.prefered_delivery_time_max.slice(0, 5)}}</label>
                <label v-else></label>
              </p>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <h5>
            <b>Data Penerima</b>
          </h5>
          <b-row>
            <b-col>
              <b>Nama Penerima</b>
              <p>{{compare ? compare.shipment_data.receiver:''}}</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b>No Telepon Penerima</b>
              <p>{{compare ? compare.shipment_data.receiver_phone:''}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b>Alamat Penerima</b>
              <p>{{compare ? compare.shipment_data.receiver_address:''}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b>Status Terakhir - Time Stamp</b>
              <p>
                {{compare ? compare.shipment_data.latest_status:''}}&nbsp;-
                <label
                  v-if="compare"
                >{{compare.shipment_data.latest_status_datetime | DateTime}}</label>
                <label v-else></label>
              </p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-button
        block
        variant="light"
        class="bg-gray-100 text-primary font-weight-bold"
        @click="modalData = !modalData"
      >Tutup</b-button>
    </b-modal>
    <b-modal v-model="commentShow" id="modal-prevent-closing" hide-header hide-footer>
      <h4>Tambah Komentar</h4>
      <br />
      <b-form-textarea
        id="textarea"
        v-model="comment"
        placeholder="New Comment...."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="commentShow = !commentShow"
            class="text-primary"
            block
            size="lg"
          >Batal</b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="postComment()" block size="lg">Post</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      v-model="emailShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
    >
      <h4>Kirim ke Email</h4>
      <br />
      <form data-vv-scope="form-email">
        <input
          id="input-1"
          type="text"
          class="form-control"
          name="email"
          v-validate="'required|email'"
          v-model="email"
          placeholder="Email"
        />
        <p
          class="text-danger"
          style="width:100%;margin-top:.25rem;font-size: 80%;"
        >{{ veeErrors.first('form-email.email') }}</p>
        <br />
        <ckeditor
          :editor="editor"
          tag-name="textarea"
          id="message"
          placeholder="Content Email"
          v-model="email_content"
          v-validate="'required'"
          name="email_content"
          data-vv-as="Content Email"
          :config="editorConfig"
        ></ckeditor>
        <p
          class="text-danger"
          style="width:100%;margin-top:.25rem;font-size: 80%;"
        >{{ veeErrors.first('form-email.email_content') }}</p>
      </form>
      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="cancelSendEmail()"
            class="text-primary"
            block
            size="lg"
          >Batal</b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" :disabled="loadingEmail" @click="postEmail()" block size="lg">
            <b-spinner label="Spinning" v-show="loadingEmail"></b-spinner>Kirim
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="transferUserTakenShow" id="modal-prevent-closing" hide-header hide-footer>
      <h4>Transfer Claim Ticket</h4>
      <br />
      <b-form-select
        v-model="transferred_username"
        class="my-0"
        id="input-1"
      >
        <template v-slot:first>
          <option value disabled>-- Pilih --</option>
        </template>
        <option
          v-for="claim_user in claim_users" :key="claim_user.id"
          :value="claim_user.username"
        >
        {{claim_user.fullname}}
        </option>
      </b-form-select>
      <br />
      <br />
      <br />
      <b-row>
        <b-col>
          <b-button
            variant="light"
            @click="transferUserTakenShow = !transferUserTakenShow"
            class="text-primary"
            block
            size="lg"
          >Batal</b-button>
        </b-col>
        <b-col>
          <b-button variant="primary" @click="postTransferUserTaken()" block size="lg">Transfer Ticket</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import selectStatus from "./SelectStatusAutoClaim";
import axios from "axios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { mixInCkeditor } from "@/mixin/mixInCkeditor";
import selectRejectReason from "./SelectRejectReasonAutoClaim.vue";
import selectAdminHub from "./SelectAdminHubAutoClaim.vue";

export default {
  mixins: [mixInCkeditor],
  components: {
    selectStatus: selectStatus,
    selectRejectReason,
    selectAdminHub,
  },
  data() {
    return {
      editor: ClassicEditor,
      contoh_date: "2018-02-13T21:05:57+07:00",
      items: [],
      item_type: [],
      listBank: [],
      compare: "",
      asuransi: true,
      claim_dokumen: true,
      claim_info: true,
      claim_menu: true,
      editClaim: true,
      menu: false,
      modalKelengkapan: false,
      modalData: false,
      modalShow: false,
      emailShow: false,
      commentShow: false,
      comment: "",
      selected: null,
      loading: true,
      loadingEmail: false,
      external: "",
      internal: "",
      image: "",
      invoice_image: "",
      identity_card_image: "",
      urlImageSelected: {
        invoice_image: "",
        identity_card_image: "",
      },
      conto_reason: ["5eafe6150f9d845867b02df8", "5eafe6150f9d845867b02df9"],
      imageItem: ["", "", ""],
      urlImage: ["", "", ""],
      chronology: "",
      hero_id_card: "",
      hero_tools_and_vehicle: "",
      letter_of_demand: "",
      preventive_action: "",
      other_document: "",
      claim_reason: [],
      logs: [],
      modalImage: false,
      email: "",
      message: "",
      session: this.$session.get("jwt"),
      url_detail: window.location.href,
      email_content: "",
      claim_reject_reasons: [],
      admin_hubs: [],
      transferUserTakenShow: false,
      claim_users: [],
      transferred_username: "",
      post_refunded_access_logs: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$swal({
      title: "Tinggalkan laman ini??",
      text: "Setiap perubahan yang belum disimpan akan dibuang",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.value) {
        next();
      } else {
        next(false);
      }
    });
  },
  beforeCreate() {
    this.$store.dispatch("cxAutoClaim/getCxReport", this.$route.params.id);
    this.$store
      .dispatch("cxAutoClaim/getClaimReason")
      .then((response) => {
        this.claim_reason = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.$store
      .dispatch("cxAutoClaim/getClaimRejectReason")
      .then((response) => {
        this.claim_reject_reasons = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.$store
      .dispatch("cxAutoClaim/getClaimAdminHub")
      .then((response) => {
        this.admin_hubs = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.$store
      .dispatch("cxAutoClaim/getClaimUsers")
      .then((response) => {
        this.claim_users = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.$store.dispatch("getItemtype");
    this.$store
      .dispatch("cxAutoClaim/getListBank")
      .then((response) => {
        this.listBank = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    this.$store
      .dispatch("cxAutoClaim/getCxPostRefundedAccessLogs", this.$route.params.id)
      .then((response) => {
        this.post_refunded_access_logs = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  beforeMount() {
    window.onbeforeunload = function () {
      return "Dude, are you sure you want to leave? Think of the kittens!";
    };
  },
  mounted() {
    // Set the initial number of items
    this.$store.watch(
      (state) => state.cxAutoClaim.report_id,
      (newValue, oldValue) => {
        this.items = newValue;
        if (this.items.processed_by && this.items.processed_by.status) {
          this.transferred_username = this.items.processed_by.user
        }
        this.email_content = `No Tiket Claim ${this.items.ticket_no} <br> AWB ${this.items.shipment_code}<br>${this.url_detail}`;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );
    this.$store.watch(
      (state) => state.item_type,
      (newValue, oldValue) => {
        this.item_type = newValue;
      }
    );
  },
  computed: {
    IsUserProcessedBy() {
      if (this.items.processed_by.user == '') {
        return true;
      }
      return this.items.processed_by.user == this.session.username
    },
    formattedProcessedByDatetime() {
        return moment(this.items.processed_by.datetime).format('YYYY-MM-DD - HH:mm');
    }
  },
  methods: {
    updateAccountBank(value, e) {
      this.items.account_bank = e
    },
    forceFileDownload(url, label) {
      if (label) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", label); //or any other extension
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
      }
      // const url = window.URL.createObjectURL(new Blob([response.data]));
    },

    async download(url) {
      fetch(
        "http://s3-ap-southeast-1.amazonaws.com/paxeldev/revamp/identity-card-IB46THF-1MTKJVF-JFKT23V-LIB768D.jpg",
        {
          method: "GET",
          responseType: "blob",
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          // Read the response as json.
          this.forceFileDownload(response);
        })
        .catch(function (error) {
          console.log("Looks like there was a problem: \n", error);
        });

      // axios({
      //   method: "get",
      //   url:
      //     "http://s3-ap-southeast-1.amazonaws.com/paxeldev/revamp/identity-card-IB46THF-1MTKJVF-JFKT23V-LIB768D.jpg",
      //   headers: {
      //     "content-type": "application/json",
      //     Authorization: null
      //   },
      //   responseType: "arraybuffer"
      // })
      //   .then(response => {
      //     this.forceFileDownload(response);
      //   })
      //   .catch(() => console.log("error occured"));
    },

    copy() {
      var dummy = document.createElement("input"),
        text = window.location.href;

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      this.$swal({
        title: "Tautan Tersalin",
        type: "success",
        showConfirmButton: false,
        timer: 1000,
      });
      document.body.removeChild(dummy);
    },
    refresh() {
      this.$store.dispatch("cxAutoClaim/getCxReport", this.$route.params.id);
      this.$store
      .dispatch("cxAutoClaim/getCxPostRefundedAccessLogs", this.$route.params.id)
      .then((response) => {
        this.post_refunded_access_logs = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    batal() {
      this.$swal({
        title: "Batal Edit Document??",
        text: "Setiap perubahan yang belum disimpan akan dibuang",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.modalKelengkapan = false;
          this.refresh();
          this.chronology = "";
          this.hero_id_card = "";
          this.hero_tools_and_vehicle = "";
          this.letter_of_demand = "";
          this.preventive_action = "";
          this.other_document = "";
        } else {
        }
      });
    },
    simpanDocument() {
    this.$validator.validateAll("form-document").then(result => {
        if (result) {
          this.$swal({
            title: "Simpan Perubahan??",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Simpan",
            cancelButtonText: "Batal",
          }).then((result) => {
            if (result.value) {
              this.modalKelengkapan = false;
              this.loading = true;
              const formData = new FormData();
              formData.append("chronology", this.chronology);
              formData.append("herotoolsandvehicle", this.hero_tools_and_vehicle);
              formData.append("heroidcard", this.hero_id_card);
              formData.append("letterofdemand", this.letter_of_demand);
              formData.append("preventiveaction", this.preventive_action);
              formData.append("otherdocument", this.other_document);
              this.$store
                .dispatch("cxAutoClaim/putCxDocument", {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$swal({
                    title: "Change!",
                    text: "Your status has been change.",
                    type: "success",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.refresh();
                  console.log(response);
                  this.$validator.reset();
                })
                .catch((error) => {
                  this.loading = false;
                  this.serverError = error.response;
                  console.log(error);
                });
            } else {
            }
          });
        } else {
           this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    buang() {
      this.$swal({
        title: "Buang Perubahan??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Buang",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.value) {
          this.editClaim = true;
          this.$validator.reset();
          this.refresh();
          this.imageItem = ["", "", ""];
          this.urlImage = ["", "", ""];
          this.invoice_image = "";
          this.identity_card_image = "";
          this.urlImageSelected.invoice_image = "";
          this.urlImageSelected.identity_card_image = "";
        } else {
        }
      });
    },
    simpan() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const claimStatus = this.items.status
          const editInputType = claimStatus == "refunded" ? "text" : "";
          const editInputLabel = claimStatus == "refunded" ? "Alasan Edit Claim" : "";
          const editInputPlaceholder = claimStatus == "refunded" ? "Masukan alasan edit claim" : "";
          this.$swal({
            title: "Simpan Perubahan??",
            type: "warning",
            input: editInputType,
            inputLabel: editInputLabel,
            inputPlaceholder: editInputPlaceholder,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Simpan",
            cancelButtonText: "Batal",
            onOpen: () => {
              if (claimStatus == "refunded") {
                this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
                const input = this.$swal.getInput();
                input.oninput = () => {
                  this.$swal.getConfirmButton().removeAttribute('disabled');
                };
              }
            },
          }).then((result) => {
            if (result.value) {
              let editReason = "";
              if (claimStatus == "refunded" && typeof result.value === 'string') {
                editReason = result.value;
              }

              this.editClaim = true;

              const formData = new FormData();
              formData.append("shipment_code", this.items.shipment_code);
              formData.append(
                "company_account_number",
                this.items.company_account_number
              );
              formData.append("company_name", this.items.company_name);
              formData.append("name", this.items.name);
              formData.append("send_as", this.items.send_as);
              formData.append("contact_number", this.items.contact_number);
              formData.append("email", this.items.email);
              formData.append("sender_name", this.items.sender_name);
              formData.append("sender_address", this.items.sender_address);
              formData.append("receiver_name", this.items.receiver_name);
              formData.append("receiver_address", this.items.receiver_address);
              formData.append("item_type_value", this.items.item_type_value);
              formData.append(
                "item_type_description",
                this.items.item_type_description
              );

              $.each(this.items.claim_reasons, (index, value) => {
                formData.append("claim_reasons", value);
              });

              formData.append(
                "is_with_additional_insurance",
                this.items.is_with_additional_insurance
              );
              formData.append(
                "additional_insurance_amount",
                this.items.additional_insurance_amount
              );
              formData.append("claim_amount", this.items.claim_amount);
              formData.append("account_bank", this.items.account_bank);
              formData.append("account_number", this.items.account_number);
              formData.append(
                "account_number_holder_name",
                this.items.account_number_holder_name
              );
              formData.append("message", this.items.message);

              $.each(this.imageItem, (index, value) => {
                formData.append("image[" + index + "]", value);
              });

              formData.append("identity_card_image", this.identity_card_image);
              formData.append("invoice_image", this.invoice_image);
              formData.append("adminhub_claim_code", this.items.admin_hub_claim.admin_hub_code);
              formData.append("adminhub_claim_name", this.items.admin_hub_claim.name);
              formData.append("reject_reason_id", this.items.reject_reason.id);
              formData.append("reject_reason_other_description", this.items.reject_reason.other_description);
              formData.append("edit_reason", editReason);

              this.$store
                .dispatch("cxAutoClaim/putCxData", {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  let timerSuccess = 1000;
                  let messageSuccess = "Claim Telah di Ubah";
                  if (claimStatus == "refunded") {
                    timerSuccess = 3000;
                    messageSuccess = "Segala Perubahan dari Refunded Claim akan diketahui oleh Claim Manager";
                  }
                  this.$swal({
                    title: messageSuccess,
                    type: "success",
                    showConfirmButton: false,
                    timer: timerSuccess,
                  });
                  this.refresh();
                  console.log(response);
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onEditClaim() {
      const claimStatus = this.items.status;
      if (claimStatus == 'refunded') {
        this.$swal({
          title: "Klaim yang Anda edit sudah di refund dan akan berimbas ke pelaporan klaim yang Anda proses, apakah Anda yakin akan mengubahnya?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            this.editClaim = !this.editClaim;
          }
        });
      } else {
        this.editClaim = !this.editClaim;
      }
    },
    setujuiClaim() {
      this.$swal({
        title: "Setujui Claim??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          if (this.items.status == "rejected") {
            this.$store
            .dispatch("cxModule/getCxApprove", this.$route.params.id)
            .then((response) => {
              this.loading = false;
              this.$swal({
                title: "Di Setujui!",
                text: "Claim Telah di setujui",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.refresh();
              this.emailShow = true;
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
          } else {
            this.$swal({
              title: "Checking...",
              text: "Please wait",
              imageUrl: "/img/loader_3_dots.gif",
              imageHeight: 100,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            this.$store
              .dispatch("cxAutoClaim/getCxApproveAutoClaim", this.$route.params.id)
              .then((response) => {
                console.log(response);
                console.log('response');
                this.loading = false;
                this.$swal({
                  title: "Di Setujui!",
                  text: "Claim Telah di setujui",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.refresh();
                this.emailShow = true;
                console.log(response);
              })
              .catch((error) => {
                this.$swal(error.response.data.message);
                console.log(error);
              });
          }
        }
      });
    },
    processClaim() {
      this.$swal({
        title: "Proses Claim??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: "Checking...",
            text: "Please wait",
            imageUrl: "/img/loader_3_dots.gif",
            imageHeight: 100,
            showConfirmButton: false,
            allowOutsideClick: false
          });
          this.$store
            .dispatch("cxAutoClaim/putCxProcessedBy", this.$route.params.id)
            .then((response) => {
              console.log(response);
              console.log('response');
              this.loading = false;
              this.$swal({
                title: "Di Ambil!",
                text: "Claim telah diambil",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.refresh();
              console.log(response);
            })
            .catch((error) => {
              this.$swal(error.response.data.message);
              console.log(error);
            });
        }
      });
    },
    acknowledge() {
      this.$swal({
        title: "Acknowledge??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("cxAutoClaim/getCxAcknowledge", this.$route.params.id)
            .then((response) => {
              this.loading = false;
              this.$swal({
                title: "Mengetahui!",
                text: "Claim Telah di ketahui",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.refresh();
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    postComment() {
      const formData = {
        comment: this.comment,
      };
      this.$store
        .dispatch("cxAutoClaim/postCxComment", {
          id: this.$route.params.id,
          formData,
        })
        .then((response) => {
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.comment = "";
          this.commentShow = false;
          this.refresh();
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    postEmail() {
      const formData = new FormData();
      this.loadingEmail = true;
      this.$validator.validateAll("form-email").then((result) => {
        if (result) {
          formData.append("email", this.email);
          formData.append("message", this.email_content);
          this.$store
            .dispatch("cxAutoClaim/postCxEmail", {
              id: this.$route.params.id,
              formData,
            })
            .then((response) => {
              this.$swal({
                type: "success",
                title: "Email Send!",
                showConfirmButton: false,
                timer: 1500,
              });
              this.email = "";
              this.email_content = `No Tiket Claim ${this.items.ticket_no} <br> AWB ${this.items.shipment_code}<br>${this.url_detail}`;
              this.loadingEmail = false;
              this.emailShow = false;
              this.refresh();
              console.log(response);
              this.$validator.reset();
            })
            .catch((error) => {
              this.loadingEmail = false;
              this.$swal({
                type: "error",
                title: "Something wrong!",
                text: error.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error.message);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadingEmail = false;
        }
      });
    },
    cancelSendEmail() {
      this.refresh();
      this.emailShow = !this.emailShow
    },
    GetData() {
      this.modalData = true;
      this.$store
        .dispatch("cxAutoClaim/getCxCompare", this.$route.params.id)
        .then((response) => {
          this.compare = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLogs() {
      this.menu = true;
      this.$store
        .dispatch("cxAutoClaim/getCxLogs", this.$route.params.id)
        .then((response) => {
          this.logs = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          const idData = {
            id: this.$route.params.id,
            comment_id: id,
          };
          this.$store
            .dispatch("cxAutoClaim/delComment", idData)
            .then((response) => {
              this.$swal("Deleted!", "Your file has been deleted.", "success");
              console.log(response);
              this.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
    print() {
      let reason = "";
      let image = "";
      let invoicePrint = "";
      let identityPrint = "";

      $.each(this.claim_reason, (index, value) => {
        $.each(this.items.claim_reasons, (key, data) => {
          if (value.id == data) {
            const print = "<li>" + value.description + "</li>";
            reason += print;
          } else {
            ("");
          }
        });
      });
      $.each(this.items.image, (key, data) => {
        const print = `<img src="${data}" width="50%" class="py-2" alt />`;
        image += print + "<br>";
      });
      console.log(image);

      if (this.checkPDFFile(this.items.invoice_image)) {
        invoicePrint = `<p>Untuk dokumen pendukung berupa file pdf di print secara terpisah</p>`;
      } else {
        invoicePrint = `<img src="${this.items.invoice_image}" width="50%" class="py-2" alt />`;
      }

      if (this.checkPDFFile(this.items.identity_card_image)) {
        identityPrint = `<p>Untuk dokumen pendukung berupa file pdf di print secara terpisah</p>`;
      } else {
        identityPrint = `<img src="${this.items.identity_card_image}" width="50%" class="py-2" alt />`;
      }
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>  
  </head>
  <body>
  <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center" style="max-width:640px; width:100%;"
        bgcolor="#FFFFFF">
        <tr>
            <td align="center" valign="top" style="padding:0px;">
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="max-width:100%; width:100%;">
                    <tr>
                        <td align="left" valign="center" style="padding:0px;">
                        <label style="font-family: 'Arial';font-size: 23px;"><b>Formulir Klaim</b></label>
                        </td>
                        <td align="right" valign="top" style="padding:0px;">
                            <img height="40" src="/logo_claim.svg"
                                alt="" srcset="">
                        </td>
                        <tr>
                    </tr>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
  <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center" style="max-width:640px; width:100%;font-family: 'Arial';font-size: 12px;"
        bgcolor="#FFFFFF">
        <tr>
            <td align="center" valign="top" style="padding:10px;">
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;table-layout: fixed;">
                    
                    <tr>
                        <td align="left" style="padding-top:20px;width:40%;">
                        <b>No Tiket</b>:<br>
                        ${this.items.ticket_no}
                        </td>
                        <td align="left" style="padding-top:20px;width:60%;">
                        <b>No Resi</b>:<br>
                        ${this.items.shipment_code}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>No Akun</b>:<br>
                        ${this.items.company_account_number}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Nama Perusahaan</b>:<br>
                        ${this.items.company_name}
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-top:20px;">
                            <span
                            style="font-size: 16px;"><b>Yang mengajukan claim</b>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Nama</b>:<br>
                        ${this.items.name}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Sebagai</b>:<br>
                        ${this.items.send_as}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>No. Telepon/HP</b>:<br>
                        ${this.items.contact_number}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Email</b>:<br>
                        ${this.items.email}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Nama Pengirim</b>:<br>
                        ${this.items.sender_name}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Alamat Pengirim</b>:<br>
                        ${this.items.sender_address}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Nama Penerima</>:<br>
                        ${this.items.receiver_name}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Alamat Penerima</b>:<br>
                        ${this.items.receiver_address}
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-top:20px;">
                            <span
                            style="font-size: 16px;"><b>Informasi mengenai claim</b>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Jenis Paket</b>:<br>
                        ${this.items.item_type_value}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Isi Paket</b>:<br>
                        ${this.items.item_type_description}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Alasan Claim</b>:<br>
                        ${reason}
                        </td>
                    </tr>
                    
                </table>
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;">
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Apakah paket dikirim dengan asuransi tambahan?</b>:<br>
                        ${
                          this.items.is_with_additional_insurance ? "Yes" : "No"
                        }
                        </td>
                    </tr>
                    <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Nominal Pengajuan</b>:<br>
                        ${this.items.claim_amount}
                        </td>
                    </tr>
                </table>
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;table-layout: fixed;">
                 <tr>
                        <td align="left" style="padding-top:20px;width:40%;">
                        <b>Nama Bank</b>:<br>
                        ${this.items.account_bank}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>No Rekening</b>:<br>
                        ${this.items.account_number}
                        </td>
                        <td align="left" style="padding-top:20px;">
                        <b>Nama Sesuai No Rekening</b>:<br>
                        ${this.items.account_number_holder_name}
                        </td>
                    </tr>
                </table>
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;">
                 <tr>
                        <td align="left" style="padding-top:20px;">
                        <b>Keterangan Tambahan</b>:<br>
                        ${this.items.message}
                        </td>
                    </tr>
                </table>
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;table-layout: fixed;">
                 <tr>
                      <td align="left" style="padding-top:20px;width:40%;">
                        <b>Asuransi</b>:<br>
                        ${this.items.shipment_insurance}
                      </td>
                      <td align="left" style="padding-top:20px;color:#ff434f;width:60%;">
                        <b>Jaminan Makanan Aman</b>:<br>
                        ${
                          this.items.food_safe_guarantee ? "Yes" : "No"
                        }
                      </td>
                    </tr>
                </table>
                <div style="clear: both;page-break-before: always;min-height: 1px;"></div>
                <table width="100%" cellspacing="0" cellpadding="0" border="0" align="center"
                    style="width:100%;">
                 <tr>
                        <td style="padding-top:20px;">
                            <span
                            style="font-size: 16px;"><b>Dokumen Pendukung</b>
                            </span>
                        </td>
                    </tr>
                 <tr>
                        <td style="padding-top:20px;">
                        <b>Foto Barang</b>:<br><br>
                            ${image}
                        </td>
                    </tr>
                 <tr>
                        <td style="padding-top:20px;">
                        <b>Invoice Pembelian Barang</b>:<br><br>
                            ${invoicePrint}
                        </td>
                    </tr>
                 <tr>
                        <td style="padding-top:20px;">
                        <b>Foto KTP</b>:<br><br>
                            ${identityPrint}
                        </td>
                    </tr>
                </table>
                
            </td>
        </tr>
    </table>
  </body>
</html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function () {
        WinPrint.print();
      }, 5000);

      // WinPrint.close();
    },
    onChangeimage(key) {
      this.imageItem[key] = this.$refs.image[key].files[0];
      this.items.image[key] = "Change File";
      const input = this.$refs.image[key];
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlImage.splice(key, 1, e.target.result);
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },

    onChangeImageSelected(value) {
      this[value] = this.$refs[value].files[0];
      this.items[value] = "Change File";
      const input = this.$refs[value];
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlImageSelected[value] = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeTransfer() {
      this.$swal({
        title: "Simpan Perubahan??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          formData.append(
            "transfer_receipt",
            this.$refs.transfer_receipt.files[0]
          );
          this.$store
            .dispatch("cxAutoClaim/putCxTransfer", {
              id: this.$route.params.id,
              formData,
            })
            .then((response) => {
              this.$swal({
                title: "Berhasil!",
                text: "Bukti tranfser berhasil di tambahkan",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.refresh();
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
    deleteTransfer() {
      this.$swal({
        title: "Hapus Bukti Transfer??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          formData.append("transfer_receipt", "delete");
          this.$store
            .dispatch("cxAutoClaim/deleteCxTransfer", {
              id: this.$route.params.id,
            })
            .then((response) => {
              this.$swal({
                title: "Terhapus!",
                text: "Bukti Transfer telah dihapus",
                type: "success",
                showConfirmButton: false,
                timer: 1000,
              });
              this.refresh();
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });
    },
    onChangeDocument(value) {
      const field = "form-document." + value;
      this.$validator.validate(field);
      this[value] = this.$refs[value].files[0];
      this.items.document[value].name = "Change File";
      const input = this.$refs[value];
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    deleteDocument(value) {
      this.$swal({
        title: "Delete Document??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const matchOptions = {
            name: value,
            scope: "form-document",
          };

          const field = this.$validator.fields.find(matchOptions);
          field.reset();
          this.$validator.errors.remove(field.name, field.scope);
          this.$refs[value].value=null;
          this[value] = "delete";
        } else {
        }
      });
    },
    deleteDataPendukung(value) {
      this.$swal({
        title: "Delete Document??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this[value] = "delete";
        } else {
        }
      });
    },
    deleteDataImage(key) {
      this.$swal({
        title: "Delete Document??",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.imageItem.splice(key, 1, "delete");
          this.urlImage.splice(key, 1, "");
          this.$refs.image[key].value = null;
        } else {
        }
      });
    },
    checkPDFFile(value) {
      if (value.includes('pdf')) {
        return true;
      }
      return false;
    },
    postTransferUserTaken() {
      const userTakenBefore = this.items.processed_by.user;
      const userTakenAfter = this.transferred_username;
      const userTransferredBy = this.session.username;
      if (userTakenBefore == userTakenAfter) {
        const messageNotAllowed = `Mohon maaf, tiket tidak bisa di transfer kepada tim yang sedang memproses`;
        this.$swal({
            type: "warning",
            title: messageNotAllowed,
            showConfirmButton: false,
            timer: 1500,
          });

        return;
      }

      const formData = {
        username: this.transferred_username,
      };
      this.$store
        .dispatch("cxAutoClaim/postCxTransferUserTaken", {
          id: this.$route.params.id,
          formData,
        })
        .then((response) => {
          let message = `Tiket telah di transfer dari ${userTakenBefore} kepada ${userTakenAfter} oleh ${userTransferredBy}`;
          if (userTakenBefore == "") {
            message = `Tiket telah di transfer kepada ${userTakenAfter} oleh ${userTransferredBy}`;
          }
          this.$swal({
            type: "success",
            title: message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.transferUserTakenShow = false;
          this.refresh();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-enter-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.5s;
  -webkit-transition-duration: 0.5s;
  -o-transition-duration: 0.5s;
  transition-duration: 0.5s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.no-hover:hover {
	color: #858796;
  background-color: transparent;
}
</style>
